import cryptoJs from "crypto-js";
import { CAPS_Y, DECLRATION_IDS, YES } from "./constants";
import { getConfigFromStroage } from "./getUrlsFromAws";

export const encryptedDataWithECBAlgo = (text) => {
    let urlsData = getConfigFromStroage();
    const defaultEncryptionKey = urlsData["defaultEncryptionKey"];
    let key = defaultEncryptionKey
    let encryptedBase64Key = btoa(key);
    let parsedBase64Key = cryptoJs.enc.Base64.parse(encryptedBase64Key);
    let encryptedData = "";
    encryptedData = cryptoJs.AES.encrypt(text, parsedBase64Key, {
      mode: cryptoJs.mode.ECB,
      padding: cryptoJs.pad.Pkcs7,
    });
    return encryptedData.toString();
  };


export const formatCustomerResponse = (CR) => {
  if (CR) {
    return CR.split(",")
  }

  return null
}

export const handleDropdownOptionForEngLang = (optTxt) => {
  const selectedLang = localStorage.getItem("LanguageSelected")
  const isDhu = localStorage.getItem("isDhuMedical") === "Y"
  if (selectedLang === "eng" || isDhu) {
    return optTxt
  } else {
    if (optTxt?.split("/")) {
      return optTxt?.split("/")[0]
    } else {
      return optTxt
    }
  }
}

export const createObjectUrlFromBase64 = (base64Data, fileType) => {
  let byteCharacters = atob(base64Data)
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: fileType })
  const url = URL.createObjectURL(blob)
  return url
}

export const getOTPDeclarationIds = () => {
  const channelName = localStorage.getItem("channelName");
  const isNps = localStorage.getItem("isNps");
  const physicalJourneyEnabled = localStorage.getItem("physicalJourneyEnabled");
  const journeyBy = localStorage.getItem("journeyBy");
  const ulipStatus = localStorage.getItem("ulipStatus")
  const cis = localStorage.getItem("cis");
  const isWipClubbed = localStorage.getItem("isWipClubbed")
  const isPanAadharLinked = localStorage.getItem("isPanAadharLinked")
  const customerConsentAfyp = localStorage.getItem("customerConsentAfyp")
  const isPanLinked = localStorage.getItem("isPanLinked")
  const isBasbaConsentRequired = localStorage.getItem("basbaConsent") === CAPS_Y;
  const isUpfrontPaymentConsentRequired = localStorage.getItem("upfrontPaymentConsent") === CAPS_Y;

  const isTalicBi = journeyBy === "P" && isWipClubbed === "Y";
  const isPanAddhar = customerConsentAfyp == "Y" || isPanAadharLinked == "N";

  const isTmbChannelRequired = localStorage.getItem("isTmbChannel") === CAPS_Y;

  const declarationIdsList = [DECLRATION_IDS.REGULAR_OTP_DISCLAIMER];

  if(isTmbChannelRequired) {
    declarationIdsList.push(DECLRATION_IDS.TMB_CHANNEL_CONSENT)
  }

  if(isTmbChannelRequired) {
    declarationIdsList.push(DECLRATION_IDS.TMB_CHANNEL_CONSENT)
  }

  if(isBasbaConsentRequired) {
    declarationIdsList.push(DECLRATION_IDS.BASBA_CONSENT)
  }

  if(isUpfrontPaymentConsentRequired) {
    declarationIdsList.push(DECLRATION_IDS.UPFRONT_PAYMENT_CONSENT)
  }

  if (isTalicBi) {
    declarationIdsList.push(DECLRATION_IDS.TALIC_BI_DISCLAIMER);
  }

  if (isPanAddhar) {
    declarationIdsList.push(DECLRATION_IDS.PAN_ADDHAR_DECLARATION);
  }

  if (isPanLinked === "N") {
    declarationIdsList.push(DECLRATION_IDS.IS_PAN_AADHAR_LINKED);
  }

  if (physicalJourneyEnabled === "yes") {
    const id = (cis === YES) ? DECLRATION_IDS.CIS_JOURNEY_TEXT : DECLRATION_IDS.PHYSICAL_JOURNEY_TEXT;
    declarationIdsList.push(id);
    return declarationIdsList;
  }

  if (channelName === "x" || journeyBy == "P") {
    if (channelName === "x") {
      const id = (cis === YES) ? DECLRATION_IDS.CIS_DISCLAIMER_TEXT : DECLRATION_IDS.DISCLAIMER_TEXT;
      declarationIdsList.push(id);
      return declarationIdsList;
    } else {
      const id = (cis === YES) ? DECLRATION_IDS.CIS_DISCLAIMER_TEXT_FOR_GEN_OTP : DECLRATION_IDS.CLUBBED_OTP_DISCLAIMER;
      declarationIdsList.push(id);
      return declarationIdsList;
    }
  }
  if (channelName !== "x") {
    if (isNps === "Y") {
      const id = (cis === YES) ? DECLRATION_IDS.CIS_IS_NPS_DISCLAIMER_TEXT : DECLRATION_IDS.IS_NPS_DISCLAIMER_TEXT;
      declarationIdsList.push(id);
    } else if (ulipStatus === "Yes") {
      const id = DECLRATION_IDS.ULIP_DISCLAIMER_TEXT;
      declarationIdsList.push(id);
    } else {
      const id = (cis === YES) ? DECLRATION_IDS.CIS_DISCLAIMER_TEXT_FOR_GEN_OTP : DECLRATION_IDS.DISCLAIMER_TEXT_FOR_GEN_OTP;
      declarationIdsList.push(id);
    }
    return declarationIdsList;
  }
};


export const getOTPDeclarationFromStorage = (decId) => {
  const dec = sessionStorage.getItem("declarations");
  if (dec) {
    const decObj = JSON.parse(dec);
    return decObj[decId];
  }
  return "";
}

export const createBase64FromFileUrl = (fileUrl) => {
  console.log({ fileUrl })
  return new Promise((resolve, reject) => {
      fetch(fileUrl).then(function (t) {
          console.log({ t })
          if (t?.status === 200) {
              t.blob().then((b) => {
                  const objUrl = URL.createObjectURL(b);
                  const reader = new FileReader();
                  reader.readAsDataURL(b);
                  reader.onloadend = () => {
                      resolve({base64: reader.result, objUrl})
                      console.log({ reader: reader.result })
                  }
              }).catch((err) => {
                  console.log({ err })
                  reject({ errMsg: "BLOB ERROR" })
              });
          } else {
              reject({ errMsg: "fileUrl LINK EXPIRED" })
          }
      }).catch((error) => {
          console.log({ error })
          reject({ errMsg: "fileUrl FETCH ERROR" })
      });
  })
}

export const storeObjectDataInStorage = (isLocalStorage = true, obj) => {
  const storage = isLocalStorage ? localStorage : sessionStorage;
  Object.entries(obj).forEach(([key, value]) => {
    let storageKey = key;
    let storageVal = value
    if(key === "chanelName") {
      storageKey = "channelName"
      storageVal = value.toLowerCase();
    }
    if(key === "cis") {
      storageVal = value.toLowerCase();
    }
    if(key === "simplifiedJourney") {
      storageVal = value.toLowerCase();
    }
    if(key === "physicalJourneyEnabled") {
      storageVal = value.toLowerCase();
    }
    if(key === "consentDeclarationText") {
      storageVal = JSON.stringify(storageVal);
    }
    if(key === "goGreen") {
      storageKey = "showGoGreenSection"
    }
    if(key === "showNewUi") {
      storageKey = "showNewUI"
    }
    if(key === "hybridPosv") {
      storageKey = "isVideoPosv"
    }
    if(key === "needClientConsent") {
      storageKey = "customerConsentAfyp"
    }
    localStorage.setItem(storageKey, storageVal);
  });
}

export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsDataURL(file);
  });
}

export const getTodayDate = () => {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const dd = String(now.getDate()).padStart(2, "0");
  return `${yyyy}/${mm}/${dd}`;
};